import { Component, OnInit } from '@angular/core';
import { IAvisosNovidades } from '../shared/Util';
import { PainelMensagensService } from '../shared/painel-mensagens.service';
import { NgFor, NgIf } from '@angular/common';

@Component({
    selector: 'app-popup-avisos-novidades',
    templateUrl: './popup-avisos-novidades.component.html',
    styleUrls: ['./popup-avisos-novidades.component.css'],
    standalone: true,
    imports: [NgFor, NgIf]
})
export class PopupAvisosNovidadesComponent  implements OnInit{
  
  pagina = 1;
  titulo = '';
  intervalo: any;
  slides: IAvisosNovidades[] = [];

  constructor(private painelMensagensService: PainelMensagensService) { }

  ngOnInit(): void {
    this.iniciaNovidades();
   
  }

  download(){
    document.getElementById('btnRotaApp').click();
  }

  alteraPaginaSlide(obj){   
    this.titulo = obj.Titulo;
    this.pagina = obj.Pagina;
    clearInterval(this.intervalo)
  }

  randomPaginaSlide(){
    if(this.pagina == this.slides.length){
      this.pagina = 1      
    }else{
      this.pagina++;
    }
    this.titulo = this.slides[this.pagina - 1].Titulo
  }

  novaUrl(){
    let urlAtual = window.location.href;    
    if (urlAtual.includes("RadarMotoristaNew")) {
      return;
    }
    let newUrl = urlAtual.replace('RadarMotorista' , 'RadarMotoristaNew', );   
    window.location.href = newUrl;
  }

  async iniciaNovidades(){    
    this.slides = await this.painelMensagensService.dados();
    if(this.slides.length > 0){
      this.titulo = this.slides[0].Titulo;
      this.intervalo = setInterval( () => {
        this.randomPaginaSlide()
      }, 10000 );
    }  
    this.slides.forEach((element) => {
      if(element.OnPressed != undefined){
        const self = this;
        if(element.OnPressed.toString() == 'self.novaUrl') element.OnPressed = self.novaUrl;
      } 
    })
  }
}

